// Action classes
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
import { FailureAction } from "../FailureAction";
/**
 * Action fired to delete a chat message
 * Create custom action because deleting the chat message is actually to update the message's isDeleted property
 * to avoid the confusion and better logging
 */ export class DeleteChatMessageAction extends TypedAction(ActionType.DeleteChatMessageAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entityId
        };
    }
    constructor(entityType, entityId, delta, updateKey){
        super(), this.entityType = entityType, this.entityId = entityId, this.delta = delta, this.updateKey = updateKey;
    }
}
/**
 * Action fired when deleting a chat message fails
 * Create custom action because deleting the chat message is actually to update the message's isDeleted property
 * to avoid the confusion and better logging
 */ export class DeleteChatMessageFailedAction extends FailureAction {
    loggingData() {
        return {
            ...super.loggingData(),
            entityType: this.entityType,
            entityId: this.entityId,
            updateKey: this.updateKey
        };
    }
    constructor(entityType, entityId, updateKey, response, textStatus, errorThrown, errorCode){
        super(ActionType.DeleteChatMessageFailedAction, response, textStatus, errorThrown, errorCode), this.entityType = entityType, this.entityId = entityId, this.updateKey = updateKey;
    }
}
/**
 * Action fired when deleting a chat message fails
 * Create custom action because deleting the chat message is actually to update the message's isDeleted property
 * to avoid the confusion and better logging
 */ export class DeleteChatMessageSucceededAction extends TypedAction(ActionType.DeleteChatMessageSucceededAction) {
    loggingData() {
        return {
            entityType: this.entityType,
            entityId: this.entity["id"],
            updateKey: this.updateKey
        };
    }
    constructor(entityType, originalEntity, entity, updateKey){
        super(), this.entityType = entityType, this.originalEntity = originalEntity, this.entity = entity, this.updateKey = updateKey;
    }
}
/**
 * Action fired when fetching emoji metadata succeeds
 */ export class FetchEmojiMetadataSucceededAction extends TypedAction(ActionType.FetchEmojiMetadataSucceededAction) {
    loggingData() {
        return {
            locale: this.locale,
            categoriesCount: this.emojiCategories.length.toString()
        };
    }
    constructor(locale, emojiCategories){
        super(), this.locale = locale, this.emojiCategories = emojiCategories;
    }
}
/**
 * Marks a task's chat as dirty. Set by Trouter pushes; cleared on the next successful chat fetch.
 */ export class MarkChatTaskPendingRefreshAction extends TypedAction(ActionType.MarkChatTaskPendingRefreshAction) {
    loggingData() {
        return {
            taskId: this.taskId
        };
    }
    constructor(taskId){
        super(), this.taskId = taskId;
    }
}
/**
 * Stores an in-progress chat compose draft for a thread.
 */ export class SetChatComposeDraftAction extends TypedAction(ActionType.SetChatComposeDraftAction) {
    loggingData() {
        return {
            threadType: this.threadType,
            entityId: this.entityId,
            length: this.draft.htmlContent.length.toString()
        };
    }
    constructor(threadType, entityId, draft){
        super(), this.threadType = threadType, this.entityId = entityId, this.draft = draft;
    }
}
/**
 * Clears the in-progress chat compose draft for a thread.
 */ export class ClearChatComposeDraftAction extends TypedAction(ActionType.ClearChatComposeDraftAction) {
    loggingData() {
        return {
            threadType: this.threadType,
            entityId: this.entityId
        };
    }
    constructor(threadType, entityId){
        super(), this.threadType = threadType, this.entityId = entityId;
    }
}
